import type _jquery from "jquery";
import { getCookie, setCookie } from "typescript-cookie";
import { isString } from "@mcwd/typescript-type-guards";
import { GatingLevel } from "../../types/definitions/gating/gating-level.js";
import { GatingState } from "../../types/definitions/gating/gating-state.js";
import { BaseFormLogger } from "../../base-form-logger.js";

const userGatingLevelCookieName = "mc-form-gt-lvl" as const;
export const UserGatingLevelCookieWrapper = {
  get GatingLevel(): GatingState.UserCookie {
    const val = getCookie(userGatingLevelCookieName);
    return isString(val) && GatingLevel.UserCookie.includes(val as GatingLevel.UserCookie)
      ? (val as GatingLevel.UserCookie)
      : "NeedsForm";
  },
  set GatingLevel(value: GatingLevel.UserCookie) {
    if (this.GatingLevel === "FullGate") {
      return;
    }
    if (isString(value) && GatingLevel.UserCookie.includes(value)) {
      let domain = window.location.hostname;
      if (domain.endsWith(".mastercontrol.com") === false) {
        if (domain !== "localhost") {
          BaseFormLogger.warn(
            `Unexpected domain when setting "${userGatingLevelCookieName}" cookie "${domain}"`
          );
        }
        domain = "";
      }
      setCookie(userGatingLevelCookieName, value, {
        ...(domain === "" ? {} : { domain }),
        expires: 45,
        sameSite: "Strict",
        path: "/"
      });
    }
  },
};